import { render, staticRenderFns } from "./VisaExpiry.vue?vue&type=template&id=58153ff5"
import script from "./VisaExpiry.vue?vue&type=script&lang=js"
export * from "./VisaExpiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports